<template>
    <div v-loading="loading" style="width:100%;padding:0 21px;margin-top: 10px;" class="main-box-print">
        <div v-if="isXj=='false'" style="display:flex;justify-content:flex-end;padding:10px 0;">
            <el-button-group>
                <template v-if="allowEdit">
                    <el-button size="mini" @click="editClick">{{ canEdit ? '取消' : '修改' }}</el-button>
                    <el-button v-show="canEdit" size="mini" type="primary" @click="saveData">保存</el-button>
                </template>
                <el-button v-show="!canEdit" type="primary" size="mini" @click="printCard('down')">下载保存</el-button>
                <!-- <el-button v-show="!canEdit" type="primary" size="mini" @click="printCard('print')">在线打印</el-button> -->
            </el-button-group>
        </div>
        <div v-if="childrenVo" id="mainBox">
            <basicCard ref="basicCard" :vo="childrenVo" :can-edit="canEdit"></basicCard>
            <gradeCard ref="gradeCard" :vo="childrenVo" :can-edit="canEdit"></gradeCard>
        </div>
        <DoingDialog />
        <el-button-group v-if="isXj=='true'" style="position: fixed;bottom: 10px;left: 49%;">
        <el-button style="border: 1px solid #409EFF;color: #409EFF;" :disabled="pre=={}" @click="preData()">上一页</el-button>
        <el-button style="border: 1px solid #409EFF;color: #409EFF;" :disabled="next=={}" @click="nextData()">下一页</el-button>
        </el-button-group>
    </div>
</template>

<script>
import basicCard from './basicCard.vue'
import gradeCard from './gradeCard.vue'
export default {
    components: {
        basicCard,
        gradeCard
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            loginUser: this.$store.getters.loginUser,
            canEdit: 0,
            allowEdit: false,
            childrenVo: null,
            isXj: 'false',
            className: '',
            next: {},
            pre: {},
            loading: false
        }
    },
    computed: {},
    watch: {},
    created: function () {
        if (this.$route.query.isXj) {
            this.isXj = this.$route.query.isXj
        } else {
            this.isXj = 'false'
        }
        if (this.$route.query.className) {
            this.className = this.$route.query.className
        }
        if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
            this.allowEdit = true
        } else {
            this.getConfig()
        }
        this.init()
    },
    beforeDestroy: function () {
    },
    mounted: function () {
        document.title = '技工学校学生学籍卡 - ' + this.loginUser.sysName
        // console.log('loginUser', this.loginUser)
        this.$nextTick(() => {
            $('.main-box-print').parents('.el-table--border').addClass('main-box-border')
        })
    },
    methods: {
        preData() {
            this.vo.id = this.pre.id
            this.init()
        },
        nextData() {
            this.vo.id = this.next.id
            this.init()
        },
        // 初始化
        async init() {
            this.loading = true
            const res = await this.$http({
                url: `/xsgl/academicRecord/getByBasicInfoId?basicInfoId=${this.vo.id}&className=${this.className}`,
                method: 'get'
            })
            const { code, message, body } = res
            console.log(`----------------接口/xsgl/academicRecord/getByBasicInfoId?basicInfoId=${this.vo.id}返回：`, body)
            if (code === 'success') {
                this.loading = false
                const { vo } = body
                this.pre = body.pre
                this.next = body.next
                this.childrenVo = vo
            } else {
                this.loading = false
                console.error(`----------------接口/xsgl/academicRecord/getByBasicInfoId?basicInfoId=${this.vo.id}&className=${this.className}报错：`)
                console.error(message)
            }
        },
        printCard(type) {
            console.log(' this.vo======', this.vo)
            this.$bus.emit('showDoingDialog')
            this.canEdit = 0

            this.$http({
                // /xsgl/studentBasicInfo/printCpbFileDoc?classId=xxx&classCode=yyy&className=ggg&majorId=tttttttttt&basicInfoId=00022d320ed342d3b2da91b72bdfc3a6
                url: `/xsgl/studentBasicInfo/printCpbFileDoc?basicInfoIds=${this.childrenVo.basicInfoId}`,
                responseType: 'blob',
                method: 'get',
                data: this.vo,
                params: {
                    topdf: type === 'print'
                }
            }).then(response => {
                const content = response
                const blob = new Blob([content])
                if (type === 'print') { // 打印
                    const fileurl = URL.createObjectURL(blob)
                    window.open('/plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl))
                } else if (type === 'down') { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = '技工学校学生学籍卡.doc'
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, downloadName)
                }
                this.$bus.emit('closeDoingDialog')
            })
        },
        editClick() {
            this.canEdit = this.canEdit ? 0 : 1
        },
        async getConfig() {
            const _this = this
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/base/paramConfig/findParamValueByName',
                params: {
                    orgCode: this.loginUser.orgCode,
                    paramName: 'student.edit.info'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    if (res.body.value) {
                        const paramsArr = res.body.value.split('_')
                        const type = paramsArr[0]
                        // 格式：0_2025-05-01_2025-05-30。注：1允许，不限时间 2允许，指定时间 0禁止
                        if (type == 1) {
                            _this.allowEdit = true
                        } else if (type == 0) {
                            _this.allowEdit = false
                        } else if (type == 2) {
                            let startTime = paramsArr[1] + ' 00:00:00'
                            let endTime = paramsArr[2] + ' 23:59:59'
                            let currentTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                            if (new Date(startTime).getTime() < new Date(currentTime).getTime() && new Date(endTime).getTime() > new Date(currentTime).getTime()) {
                                _this.allowEdit = true
                            } else {
                                _this.allowEdit = false
                            }
                        }
                    } else {
                        if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
                            _this.allowEdit = true
                        } else {
                            _this.allowEdit = false
                        }
                    }
                } else {
                    // _this.allowEdit = false
                    if (this.$store.getters.roles.indexOf('dwAdministrators') !== -1) {
                        _this.allowEdit = true
                    } else {
                        _this.allowEdit = false
                    }
                }
            })
        },
        async saveData() {
            const formData = {
                ...this.childrenVo,
                passenger: {
                    scoresList: this.$refs.gradeCard.scoresList
                },
                evaluateRecord: this.$refs.basicCard.evaluateRecord,
                evaluateList: JSON.stringify(this.$refs.basicCard.evaluateList),
                internshipSituations: JSON.stringify(this.$refs.gradeCard.internshipSituations),
                otherSituations: JSON.stringify(this.$refs.gradeCard.otherSituations),
                attendanceSituations: JSON.stringify(this.$refs.gradeCard.attendanceSituations),
                graduateSituations: JSON.stringify(this.$refs.gradeCard.graduateSituations)
            }
            console.log('----------------------------')
            console.log(this.$refs.gradeCard.scoresList) // 分数
            console.log(this.$refs.basicCard.evaluateRecord) // 奖惩记录

            console.log(this.$refs.basicCard.evaluateList) // 学生操行评定及毕业鉴定
            console.log(this.$refs.gradeCard.internshipSituations) // 生产实习情况
            console.log(this.$refs.gradeCard.otherSituations) // 休、退、转、复学记录
            console.log(this.$refs.gradeCard.attendanceSituations) // 考勤
            console.log(this.$refs.gradeCard.graduateSituations) // 毕业情况
            console.log('----------------------------')
            const res = await this.$http({
                url: `/xsgl/academicRecord/update`,
                method: 'put',
                data: formData
            })
            const { code, message, body } = res
            if (code === 'success') {
                this.canEdit = 0
                this.$message.success('保存成功')
            } else {
                console.error(`----------------接口/xsgl/academicRecord/update报错：`)
                console.error(message)
                this.$message.error(message)
            }
        }
    }
}
</script>
<style lang="scss">
#new-busi-form .main-box-border {
    border: none !important;

    &::before {
        background-color: transparent !important;
    }

    &::after {
        background-color: transparent !important;
    }
}
</style>
<style scoped>
@media print {
    body {
        font-size: 10pt;
        /* 设置打印字体大小 */
    }

    .no-print {
        display: none;
        /* 隐藏不需要打印的元素 */
    }

    .page-break {
        page-break-after: always;
        /* 添加分页符 */
    }
}

@page {
    size: A3;
    /* 设置页面尺寸为A4 */
    margin: 1cm;
    /* 设置页面边距 */
}
</style>
